export default __webpack_public_path__ + "static/media/vuesax-linear-eye.6cbd8a1b.svg";